export default function () {
	const selects = document.querySelectorAll('select');

	function onChange(el) {
		if(!el.value) {
			el.classList.add('is-null')
		} else {
			el.classList.remove('is-null')
		}
	}

	[].forEach.call(selects, function(v, i) {
		v.addEventListener('change', function(e) {
			const el = e.currentTarget;
			onChange(el);
		});
		onChange(v);
	})
}
